import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DateTimePicker } from '@material-ui/pickers';

import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';

// stuff for dialog - move if separating
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Collapse from '@material-ui/core/Collapse';

import PaginatedTable from 'app/components/tables/PaginatedTable';

import { containerFull} from 'app/styles/new-layout';

import useApp from 'app/context/useApp';


const renderDateInput = props => (
    <TextField
        variant="outlined"
        fullWidth
        className={props.className}
        onClick={props.onClick}
        id={props.id}
        value={props.value}
        disabled={props.disabled}
        label={props.label}
        helperText={props.helperText}
        {...props.inputProps}
    />
);

const useFilterStyles = makeStyles(theme => ({
    subSection: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.grey[200]
    },
    subSectionLoading: {
        textAlign: 'center',
        padding: theme.spacing(3),
        backgroundColor: theme.palette.grey[200]
    },
    dialogSpacing: {
        padding: theme.spacing(1)
    },
    noSpacing: {
        padding: 0
    },
    noMarginLeft: {
        marginLeft: 0
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    empty: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    noContentPadding: {
        padding: 0
    }
}));

const PaymentsFilterDialog = (props) => {

    const classes = useFilterStyles()

    const { open, onClose, onFilter } = props;
    const { app } = useApp();

    const [ filters, setFilters ] = useState([]);
    const [ filtersChecked, setFiltersChecked ] = useState([]);
    const [ methodFiltersChecked, setMethodFiltersChecked ] = useState([]);
    const [ dueByDate, setDueByDate ] = useState(null);
    const [ dueByDate2, setDueByDate2 ] = useState(null);
    const [ dueByRange, setDueByRange ] = useState("Before");

    // filter objects ------------------------------------

    const statuses = [
        'Succeeded',
        'Incomplete',
        'Uncaptured',
        'Disputed',
        'Pending',
        'Failed',
        'Canceled',
        'Early Fraud Warning',
    ]

    const dateRange = [
        'Before',
        'After',
        'Between',
        'Outside',
    ]

    const dualDates = [ "Between", "Outside" ]

    const paymentMethods = [
        'Credit Card',
        'Check'
    ]

    const getFilters = () => {
        const newFilters = app.user.application_state.users.filters;
        const activeFilters = [];

        if (newFilters.groups && newFilters.groups instanceof Array && newFilters.groups.length > 0) {
            setGroupsChecked(newFilters.groups);
            activeFilters.push('groups')
        }

        if (newFilters.levels && newFilters.levels instanceof Array &&
            newFilters.levels.length > 0) {
            setLevelsChecked(newFilters.levels)
            activeFilters.push('membership_levels')
        }

        setFilters(activeFilters);
    }

    useEffect(() => {
        getFilters();
    }, []);


    // Posters -----------------------------

    const postFilter = () => {

        const data = {}
        const statusObject = {}
        const dueByObject = {}
        const methodObject = {}

        if (filters.indexOf('status') > -1) {
            statusObject.type = 'array';
            statusObject.id = 'status';
            statusObject.array = filtersChecked;
            data.status = statusObject;
        }

        if (filters.indexOf('due_by') > -1 && dueByDate) {
            dueByObject.type = 'date';
            dueByObject.id = 'due_by';
            dueByObject.date_range = dueByRange.toLowerCase();
            dueByObject.start_date = dueByDate.toSeconds();
            dueByDate2 ? dueByObject.end_date = dueByDate2.toSeconds() : null;
            data.due_by = dueByObject;
        }

        if (filters.indexOf('payment_method') > -1) {
            methodObject.type = 'array';
            methodObject.id = 'payment_method';
            methodObject.array = methodFiltersChecked;
            data.payment_method = methodObject;
        }

        console.log(data)

        onFilter(data);
        onClose();
    }

    const postClear = () => {
        setFilters([]);
        setFiltersChecked([]);
        setMethodFiltersChecked([]);
        onFilter({});
        onClose();
    }

     // Handlers --------------------------------------

     const handleFilter = filter => {
        const newFilters = [...filters];
        const i = newFilters.indexOf(filter)

        if (i > -1) {
            newFilters.splice(i, 1)
        } else {
            newFilters.push(filter)
        }

        setFilters(newFilters);
    }

    const handleClose = () => {
        onClose();
    }

    const handleChecked = type => {

        const newChecked = [...filtersChecked];

        const i = newChecked.indexOf(type);

        if (i > -1) {
            newChecked.splice(i, 1);
        } else {
            newChecked.push(type);
        }

        setFiltersChecked(newChecked);
    }

    const handleMethodFiltersChecked = type => {

        const newChecked = [...methodFiltersChecked];

        const i = newChecked.indexOf(type);

        if (i > -1) {
            newChecked.splice(i, 1);
        } else {
            newChecked.push(type);
        }

        setMethodFiltersChecked(newChecked);
    }

    // range select -------------------------------

    const handleDueByRange = (value) => {
        setDueByRange(value);
    }

    // date handlers ------------------------------

    const handleDueByDate = (value) => {
        setDueByDate(value);
    }

    const handleDueByDate2 = (value) => {
        setDueByDate2(value);
    }

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            fullWidth
            aria-labelledby="filter-users"
        >
            <DialogTitle className={classes.dialogSpacing}>
                <Grid container direction="row" justify="space-between">
                    <Grid item>
                        <Button variant="outlined" color="primary" onClick={postClear}>
                            Clear
                        </Button>
                    </Grid>
                    <Grid item>
                        Filters
                    </Grid>
                    <Grid item>
                        <Button color="primary" variant="contained" onClick={postFilter}>
                            Filter
                        </Button>
                    </Grid>
                </Grid>
            </DialogTitle>
            <Divider />
            <DialogContent className={classes.noContentPadding}>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={(filters.indexOf('status') > -1)}
                            onChange={()=>handleFilter('status')}
                            name="payment-status"
                            color="primary"
                        />
                    }
                    label="Payment Status"
                />
                <Divider />
                <Collapse in={(filters.indexOf('status') > -1)}>
                    <FormGroup className={classes.subSection}>
                        {statuses.map(status => (
                            <FormControlLabel
                                key={status}
                                className={classes.noMarginLeft}
                                control={
                                    <Checkbox
                                        checked={(filtersChecked.indexOf(status) > -1)}
                                        onChange={()=>handleChecked(status)}
                                        name={status}
                                        color="primary"
                                    />
                                }
                                label={status}
                            />
                        ))}
                        </FormGroup>
                </Collapse>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={(filters.indexOf('due_by') > -1)}
                            onChange={()=>handleFilter('due_by')}
                            name="due-by"
                            color="primary"
                        />
                    }
                    label="Payment Date"
                />
                <Divider />
                <Collapse in={(filters.indexOf('due_by') > -1)} >
                    <div className={classes.subSection}>
                        <TextField
                            select
                            variant="outlined"
                            fullWidth
                            onChange={e => handleDueByRange(e.target.value)}
                            value={dueByRange}
                            label="Date Range Type"
                            className={classes.marginTop}
                        >
                            {dateRange.map((range, index) => (
                                    <MenuItem key={index} value={range}>
                                        {range}
                                    </MenuItem>
                                ))}
                        </TextField>
                        <DateTimePicker
                            label={dueByRange === 9 ? "Choose Start Date" : dueByRange === 10 ? "Choose Start Date" : "Choose Date"}
                            inputVariant="outlined"
                            value={dueByDate}
                            onChange={(value)=>handleDueByDate(value)}
                            variant="outlined"
                            TextFieldComponent={renderDateInput}
                            minutesStep={15}
                            className={classes.marginTop}
                            clearable
                        />
                        <Collapse in={dualDates.includes(dueByRange)}>
                            <DateTimePicker
                                label="Choose End Date"
                                inputVariant="outlined"
                                value={dueByDate2}
                                onChange={(value)=>handleDueByDate2(value)}
                                variant="outlined"
                                TextFieldComponent={renderDateInput}
                                minutesStep={15}
                                className={classes.marginTop}
                                clearable
                            />
                        </Collapse>
                    </div>
                </Collapse>
                <FormControlLabel
                    className={classes.noMarginLeft}
                    control={
                        <Checkbox
                            checked={(filters.indexOf('payment_method') > -1)}
                            onChange={()=>handleFilter('payment_method')}
                            name="payment-method"
                            color="primary"
                        />
                    }
                    label="Payment Method"
                />
                <Collapse in={(filters.indexOf('payment_method') > -1)} >
                    <FormGroup className={classes.subSection}>
                        {paymentMethods.map(method => (
                            <FormControlLabel
                                key={method}
                                className={classes.noMarginLeft}
                                control={
                                    <Checkbox
                                        checked={(methodFiltersChecked.indexOf(method) > -1)}
                                        onChange={()=>handleMethodFiltersChecked(method)}
                                        name={method}
                                        color="primary"
                                    />
                                }
                                label={method}
                            />
                        ))}
                    </FormGroup>
                </Collapse>
            </DialogContent>
        </Dialog>
    )
}

const columns = [
    {id: 'status', align: 'left', disablePadding: false, label: 'Status' },
    {id: 'id', align: 'left', disablePadding: false, label: 'Payment #' },
    {id: 'invoice_number', align: 'left', disablePadding: false, label: 'Inv #' },
    {id: 'invoice_by', align: 'left', disablePadding: false, label: 'Invoice Date', type: 'date', format: 'D'},
    {id: 'due_by', align: 'left', disablePadding: false, label: 'Due Date', type: 'date', format: 'D' },
    {id: 'updated_at', align: 'left', disablePadding: false, label: 'Payment Date', type: 'date', format: 'D'},
    {id: 'user', align: 'left', disablePadding: true, label: 'Paid By' },
    {id: 'invoice_user', align: 'left', disablePadding: true, label: 'Invoiced To' },
    { id: 'description', align: 'left', disablePadding: true, label: 'Invoice Description' },
    { id: 'reporting_category', align: 'left', disablePadding: true, label: 'Reporting Category' },
    {id: 'amount', align: 'right', disablePadding: false, label: 'Invoice Total', type: 'currency', format: '$'},
    {id: 'amount_paid', align: 'right', disablePadding: false, label: 'Payment Amount', type: 'currency', format: '$'},
    {id: 'method', align: 'left', disablePadding: false, label: 'Method' },
    {id: 'failure_message', align: 'left', disablePadding: false, label: 'Failure Message' },
];

const useStyles = makeStyles(theme => ({
    container: {
        ...containerFull(theme),
    },
}));

export default function Payments(props) {

    const { app } = useApp();

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <PaginatedTable
                columns={columns}
                stateKey="payments"
                label="Payments"
                tableUrl='/payment'
                baseUrl='/admin/accounting/payment'
                exportTitle='payments-export'
                exportAllTitle='payments-export-all'
                FilterDialog={<PaymentsFilterDialog />}
                fullHeight
            />
        </div>
    );
}
